<template>
  <v-dialog v-model="visible" max-width="1000px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" sm="12" md="7" lg="8">
              <v-text-field v-model="form.nombre" label="Nombre" outlined dense hide-details></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="12" md="5" lg="4">
              <v-select
                v-model="form.proposito"
                :items="propositos"
                label="Propósito"
                placeholder="Seleccione un propósito"
                outlined
                dense
                hide-details></v-select>

              <small v-for="error in errores.proposito" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 160px"
                v-model="form.esReutilizable"
                label="Es Reutilizable"
                hide-details
                dense></v-checkbox>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 180px"
                v-model="form.permiteProrroga"
                label="Permite Prórroga"
                hide-details
                dense></v-checkbox>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 200px"
                v-model="form.aplicaFechaVencimiento"
                label="Aplica Fecha Vencimiento"
                hide-details
                dense></v-checkbox>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 160px"
                v-model="form.requiereValidacion"
                label="Requiere Validación"
                hide-details
                dense></v-checkbox>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 200px"
                v-model="form.tienePlantillaDescargable"
                label="Tiene Plantilla Descargable"
                hide-details
                dense
                @change="
                  ($event) => {
                    if (!$event) {
                      form.uriPlantillaDescargable = null;
                      errores.uriPlantillaDescargable = [];
                    }
                  }
                "></v-checkbox>
            </v-col>

            <v-col cols="12" sm="12" md="5" lg="4">
              <v-select
                v-model="form.formatoPermitido"
                :items="formatosPermitidos"
                label="Formato Permitido"
                placeholder="Seleccione un formato"
                outlined
                dense
                hide-details></v-select>

              <small v-for="error in errores.formatoPermitido" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="auto" lg="auto">
              <v-checkbox
                style="max-width: 170px"
                v-model="form.permiteCapturaCamara"
                label="Permite Captura de Cámara"
                hide-details
                dense
                :disabled="!permiteActivarFotografia"></v-checkbox>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                v-model="form.uriPlantillaDescargable"
                label="URI Plantilla Descargable"
                placeholder="Ingrese la URI de la plantilla descargable"
                :disabled="!form.tienePlantillaDescargable"
                :prefix="prefijoApiComisiones"
                outlined
                dense
                hide-details>
                <template v-slot:prepend-inner>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" v-bind="attrs" v-on="on"> mdi-information </v-icon>
                    </template>

                    <span>
                      La URI debe ser un endpoint válido que permita la descarga de la plantilla.
                      <br />
                      Ejemplo:
                      <strong>{{ `${prefijoApiComisiones}uri/para/descargar/{inscripcionId}?algo=123` }}</strong>
                      <br />
                      donde <strong>{inscripcionId}</strong> es dinámico y será reemplazado por el ID de inscripción
                      proporcionado.
                    </span>
                  </v-tooltip>
                </template>
              </v-text-field>

              <small v-for="error in errores.uriPlantillaDescargable" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field
                v-model="inscripcionId"
                type="number"
                label="ID de Inscripción de Ejemplo"
                placeholder="Ingrese un ID de inscripción de ejemplo"
                min="1"
                step="1"
                :disabled="!form.tienePlantillaDescargable"
                outlined
                dense
                hide-details></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="3">
              <v-btn
                color="primary"
                title="Descargar Plantilla"
                small
                :disabled="!form.tienePlantillaDescargable || !inscripcionId"
                @click="descargarPlantilla">
                <v-icon>mdi-download</v-icon>
                Descargar Plantilla de Ejemplo
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn color="primary" title="Agregar Campo" small @click="agregarCampo">
                <v-icon>mdi-plus</v-icon>
                Agregar Campo
              </v-btn>
            </v-col>

            <v-col cols="12">
              <transition-group name="list-complete" mode="in-out">
                <v-card
                  v-for="(campo, index) in form.plantillaDatos"
                  :key="campo.id"
                  class="list-complete-item pa-3 my-2"
                  outlined>
                  <v-row>
                    <v-col cols="12" lg="5">
                      <div class="d-flex align-center">
                        <v-btn
                          title="Mover Campo Arriba"
                          :disabled="index === 0"
                          x-small
                          @click="form.plantillaDatos.splice(index - 1, 0, form.plantillaDatos.splice(index, 1)[0])">
                          <v-icon>mdi-arrow-up-bold</v-icon>
                        </v-btn>

                        <v-btn
                          class="mr-2"
                          title="Mover Campo Abajo"
                          :disabled="index === form.plantillaDatos.length - 1"
                          x-small
                          @click="form.plantillaDatos.splice(index + 1, 0, form.plantillaDatos.splice(index, 1)[0])">
                          <v-icon>mdi-arrow-down-bold</v-icon>
                        </v-btn>

                        <div style="width: 100%">
                          <v-text-field
                            v-model="campo.nombre"
                            label="Nombre Campo"
                            outlined
                            dense
                            hide-details
                            @input="
                              ($event) => {
                                if ($event) {
                                  campo.etiqueta = convertirTextoASlug($event);
                                  errores[`plantillaDatos.${index}.nombre`] = [];
                                } else {
                                  errores[`plantillaDatos.${index}.nombre`] = errores[`plantillaDatos.${index}.nombre`];
                                }
                              }
                            "></v-text-field>

                          <small
                            v-for="error in errores[`plantillaDatos.${index}.nombre`]"
                            :key="error"
                            class="d-block text-danger">
                            {{ error }}
                          </small>
                        </div>
                      </div>
                    </v-col>

                    <v-col cols="12" lg="3">
                      <v-select
                        v-model="campo.tipo"
                        :items="tipos"
                        label="Tipo Campo"
                        outlined
                        dense
                        hide-details
                        @change="
                          ($event) => {
                            errores[`plantillaDatos.${index}.tipo`] = $event
                              ? []
                              : errores[`plantillaDatos.${index}.tipo`];

                            if ($event !== tipoOpcionMultiple) {
                              delete campo.opciones;
                              delete campo.nuevaOpcion;
                            } else {
                              $set(campo, 'opciones', []);
                              $set(campo, 'nuevaOpcion', '');
                            }
                          }
                        "></v-select>

                      <small
                        v-for="error in errores[`plantillaDatos.${index}.tipo`]"
                        :key="error"
                        class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" lg="3">
                      <v-text-field
                        v-model="campo.etiqueta"
                        label="Etiqueta"
                        readonly
                        outlined
                        dense
                        hide-details
                        @input="
                          ($event) =>
                            (errores[`plantillaDatos.${index}.etiqueta`] = $event
                              ? []
                              : errores[`plantillaDatos.${index}.etiqueta`])
                        "></v-text-field>

                      <small
                        v-for="error in errores[`plantillaDatos.${index}.etiqueta`]"
                        :key="error"
                        class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" lg="1">
                      <v-btn
                        color="red"
                        dark
                        title="Eliminar Campo"
                        small
                        @click="form.plantillaDatos.splice(index, 1)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row v-if="campo.tipo === tipoOpcionMultiple">
                    <v-col cols="12">
                      <strong class="mr-2">Opciones</strong>
                    </v-col>

                    <v-col cols="12" lg="9">
                      <v-text-field
                        v-model="campo.nuevaOpcion"
                        label="Nueva opción"
                        outlined
                        dense
                        hide-details
                        autofocus
                        @keyup.enter="confirmarOpcion(campo)"
                        @blur="confirmarOpcion(campo)">
                      </v-text-field>

                      <small
                        v-for="error in errores[`plantillaDatos.${index}.opciones`]"
                        :key="error"
                        class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" lg="3">
                      <v-btn color="primary" x-small @click="agregarOpcion(campo)">
                        <v-icon small>mdi-plus</v-icon>
                        Agregar Opción
                      </v-btn>
                    </v-col>

                    <v-col cols="12" lg="12">
                      <v-chip-group column>
                        <v-chip
                          v-for="(opcion, opcionIndex) in campo.opciones"
                          :key="opcionIndex"
                          close
                          @click:close="campo.opciones.splice(opcionIndex, 1)">
                          {{ opcion }}
                        </v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>
                </v-card>
              </transition-group>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import {
  ACCIONES,
  FORMATOS_PERMITIDOS,
  FORMATOS_PERMITIDOS_ARRAY,
  PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_ARRAY,
  TIPOS,
  TIPOS_CAMPOS,
} from '../../utils/constantes';
import TiposDocumentosPersonaService from '../../services/tipos-documentos-persona.service';
import { generarUUID } from '../../utils/funciones';
import plantillasService from '../../services/plantillas.service';

export default {
  name: 'ModalFormularioTipoDocumentoPersona',
  mixins: [modalFormMixin, apiConsumerMixin],
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.proposito': function () {
      this.errores.proposito = [];
    },
    'form.uriPlantillaDescargable': function () {
      this.errores.uriPlantillaDescargable = [];
    },
    'form.formatoPermitido': function (newVal) {
      this.errores.formatoPermitido = [];
      if (![FORMATOS_PERMITIDOS.IMAGEN, FORMATOS_PERMITIDOS.PDF_E_IMAGEN].includes(newVal)) {
        this.form.permiteCapturaCamara = false;
      }
    },
  },
  computed: {
    permiteActivarFotografia() {
      return [FORMATOS_PERMITIDOS.IMAGEN, FORMATOS_PERMITIDOS.PDF_E_IMAGEN].includes(this.form.formatoPermitido);
    },
  },
  data() {
    return {
      tipos: TIPOS,
      tiposCampos: TIPOS_CAMPOS,
      propositos: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_ARRAY,
      formatosPermitidos: FORMATOS_PERMITIDOS_ARRAY,
      tipoOpcionMultiple: TIPOS_CAMPOS.SELECCION_MULTIPLE,
      prefijoApiComisiones: process.env.VUE_APP_URL_API_COMISIONES,
      inscripcionId: 179827,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        proposito: null,
        esReutilizable: false,
        permiteProrroga: false,
        aplicaFechaVencimiento: false,
        requiereValidacion: true,
        tienePlantillaDescargable: false,
        uriPlantillaDescargable: null,
        formatoPermitido: null,
        permiteCapturaCamara: false,
        plantillaDatos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        proposito: data.proposito,
        esReutilizable: data.esReutilizable,
        permiteProrroga: data.permiteProrroga,
        aplicaFechaVencimiento: data.aplicaFechaVencimiento,
        requiereValidacion: data.requiereValidacion,
        tienePlantillaDescargable: data.uriPlantillaDescargable ? true : false,
        uriPlantillaDescargable: data.uriPlantillaDescargable,
        formatoPermitido: data.formatoPermitido,
        permiteCapturaCamara: data.permiteCapturaCamara ?? false,
        plantillaDatos: data.plantillaDatos.map((campo) => ({ ...campo })),
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    cerrar() {
      this.form.plantillaDatos = [];
      this.cerrarMixin();
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? TiposDocumentosPersonaService.update : TiposDocumentosPersonaService.create;

      await this.saveMixin(
        accion,
        fnServicio,
        this.form,
        null,
        'TIPO DOCUMENTO PERSONA',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
    agregarCampo() {
      this.form.plantillaDatos.push({ id: generarUUID(), nombre: null, tipo: this.tiposCampos.TEXTO, etiqueta: null });
    },
    convertirTextoASlug(texto) {
      const articulosYPreposiciones = [
        'a',
        'ante',
        'bajo',
        'cabe',
        'con',
        'contra',
        'de',
        'del',
        'desde',
        'durante',
        'en',
        'entre',
        'hacia',
        'hasta',
        'mediante',
        'para',
        'por',
        'según',
        'sin',
        'so',
        'sobre',
        'tras',
        'el',
        'la',
        'los',
        'las',
        'un',
        'una',
        'unos',
        'unas',
        'y',
        'o',
        'u',
      ];

      return texto
        .toString()
        .split(' ')
        .filter((t) => !articulosYPreposiciones.includes(t.toLowerCase()))
        .join(' ')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, '-');
    },
    confirmarOpcion(campo) {
      if (campo.nuevaOpcion && campo.nuevaOpcion.trim() !== '') {
        this.agregarOpcion(campo);
      }
    },
    agregarOpcion(campo) {
      if (campo.nuevaOpcion && campo.nuevaOpcion.trim() !== '') {
        campo.opciones.push(campo.nuevaOpcion.trim());
        campo.nuevaOpcion = '';
      }
    },
    async descargarPlantilla() {
      if (!this.form.tienePlantillaDescargable || !this.inscripcionId) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'La plantilla descargable no está habilitada o el ID de inscripción no es válido.',
          type: 'error',
        });

        return;
      }

      try {
        const uriConId = this.form.uriPlantillaDescargable.replace('{inscripcionId}', this.inscripcionId);
        const response = await plantillasService.descargarPlantilla(uriConId);
        const data = response.data;
        const datos = data.datos;
        const nombreArchivo = datos.nombreArchivo;
        const base64 = datos.archivoBase64;

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = nombreArchivo;
        link.click();
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'La plantilla se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        window.console.error('Error al descargar la plantilla:', error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'No se pudo descargar la plantilla. Verifique la URI y el ID de inscripción.',
          type: 'error',
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.list-complete-item {
  transition: transform 0.7s, opacity 0.7s;
}

.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>